import Cookies from 'js-cookie'

export default {
    popupPays: jQuery('#popup-pays'),
        init() {
            // JavaScript to be fired on the home page
            if (!Cookies.get('popup-pays')) {
                this.getEndUserLocation()
            } else {
                this.navigateToUrlCookie()
            }
    },

    /*
    * check if user is in Africa
     */
    async getEndUserLocation() {
        try {
            const response = await fetch('https://get.geojs.io/v1/ip/geo.json')
            if (!response.ok) {
                throw new Error(response.statusText)
            }
            const data = await response.json()
            const {country_code3, continent_code} = data;

            if (continent_code === 'AF') {
                this.triggerPopupPays(country_code3)
            }
        } catch (e) {
        }

    },

    triggerPopupPays(country_code3) {
        const aglCountries = $(this.popupPays).find('.agl-list-pays > li')
        $('body').addClass('open-popup-pays')
        this.popupPays.addClass('africa-located')

        if (aglCountries.length > 0) {
            for (let country of aglCountries) {
                const currentCountryCode = $(country).data('code')
                const currentCountryLink = $(country).find('a')
                if (country_code3 === currentCountryCode) {
                    const aglCountryInputWrapper = $(this.popupPays).find('.form-input')
                    const aglCountryInput = $(aglCountryInputWrapper).find('input[type="text"]')
                    const navigateToCountry = $('.popup-pays-cta .btn')

                    aglCountryInput.val(currentCountryLink.text())
                    navigateToCountry.attr('href', currentCountryLink.prop('href'))
                    navigateToCountry.addClass('visible')
                    aglCountryInputWrapper.addClass('country-found')
                }
            }
        }
    },

    navigateToUrlCookie() {
        const selectedCountryPage = Cookies.get('popup-pays')
        const redirectCookie = Cookies.get('redirect')
        if ( selectedCountryPage !== window.location.href ) {
            if (redirectCookie) {
                return
            }
            window.location.replace(selectedCountryPage)
            Cookies.set('redirect', true)
        }
    },

    finalize() {
        // JavaScript to be fired on the home page, after the init JS
        $(this.popupPays).find('.popup-cancel').on('click', () => {
            $('body').removeClass('open-popup-pays')
            this.popupPays.removeClass('africa-located')
            Cookies.set('popup-pays', window.location.href, {expires: 365})
        })

        $('.popup-pays-cta .btn').on('click', (e) => {
            const acceptLink = $(e.target).attr('href')
            Cookies.set('popup-pays', acceptLink, {expires: 365})
            Cookies.set('redirect', true)
        })

        $(this.popupPays).find('.agl-list-pays > li > a').on('click', (e) => {
            const acceptLink = $(e.target).attr('href')
            Cookies.set('popup-pays', acceptLink, {expires: 365})
            Cookies.set('redirect', true)
        })
    },
    };
